import Vue from "vue";
import Vuex from "vuex";
// import { languages } from '../locales/languages.js';

import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
Vue.use(Vuex);

import menuItemPlaceholderPic from "../assets/menu_item_placeholder.png";
import errorProfilePic from "../assets/question_marks.png";
import birdProfilePic from "../assets/profile_pic_toucan.png"; //.jpeg");
import newCustomersPic from "../assets/new-customers.png";
import geolocationPic from "../assets/geolocation.png";
import siilorsPic from "../assets/siilors_400w.jpeg";
import siilorIcon from "../assets/transport_menu_siilor.png";
import songthaewsPic from "../assets/songthaews_400w.jpeg";
import songthaewIcon from "../assets/transport_menu_songthaew.png";
import taxiIcon from "../assets/transport_menu_taxi.png";
import vipTaxiIcon from "../assets/transport_menu_vip_taxi.png";
import publicTuktukIcon from "../assets/transport_menu_tourist.png";

// export const store = new Vuex.Store({
export default new Vuex.Store({
  namespaced: false,
  state: {
    width: null, // screen size: window.innerWidth
    height: null, // screen size: window.innerHeight
    initialisedAt: null,
    uuid: null, // object {uuid: asbjkj, createdAt: jkljlk}
    user: null, // object
    userSource: null, // object
    userState: null, // location
    lineUser: null, // object, deprecate eventually since this is userSource
    mode: null, // mode = chosen role name, default "customer"
    roles: [], // array of roles
    superRoles: [], // additional roles used by super users
    activeCommerceAgentRoleID: null,
    businesses: [], //
    workflows: [], // workflowsByType
    forYouEat: [], // kv pairs key = business_id, value = for you eat page recommendation score
    newShops: [], // for NEW homepage list
    eatLists: [], // eat page lists
    eateries: [], // prepared food businesses
    marts: [], // marts
    transport: [], // transport businesses
    userStops: [], // users pickups and dropoffs
    yourPrivateTransport: null, // your selected private transport workflow, previously selectedTukTuk
    polylines: [], // encoded driving route polylines
    // addresses: {}, // dictionary with key address_type (home, work, etc)
    addresses: [], // dictionary with key address_type (home, work, etc)
    superUser: true, // DELETE
    secret: 0, // tap the version code to increment
    device: null, // object
    redirect: null, // string
    magicLogin: null, // obj
    loginMethod: "", // set after successful login to limit login options next time
    actions: [], // log all the actions triggered by user
    selectedBusiness: null, // set the current business
    googlePlace: null,
    googleCoords: null,
    stopCoords: null,
    selectedTukTuk: null, // your private tuktuk workflow
    selectedTransport: null, // could be your private tuktuk or siilor depending
    selectedTransportType: "", // privatetuk, localtuk
    commerceAgentTransactionsUpdatedAt: null,
    ongoingCommerceAgentTransactions: null, // e-commerce
    pastCommerceAgentTransactions: null,
    logisticsAgentFleetWorkflows: [],
    logisticsAgentTransactionsUpdatedAt: null,
    ongoingLogisticsAgentTransactions: null, // logistics
    pastLogisticsAgentTransactions: null,
    ongoingDispatcherTransactions: [], // dispatcher
    workerTransactions: null,
    ongoingWorkerTransactions: null, // is_ongoing = true
    customerTransactions: null, // active transactions
    recentCustomerTransactions: null, // past transactions
    ongoingCustomerTransactions: null, // is_ongoing = true
    isPollingLocation: false,
    language: "",
    isWorking: false, // set true if driver is working
    workingState: "", // set 'driver' or 'dispatcher' if working
    workingRole: null, // driver or dispatcher role if working
    workflowDrivers: [], // for autocomplete in dispatcher mode
    pwaPrompt: null, // was used to store pwaPrompt, trigger by pwaPrompt.prompt()
    version: "0.0",
    compassHeading: 0, // or null to start, e.g. computer won't have compass
    notificationToken: "", // save to user
    mapState: "", // driver, passenger or empty string
    timestamps: {}, // dictionary of timestamps to track last API call
    rejectedTransactions: [], // transaction ids of rejected rides for driver
    endedTransactions: [], // transaction ids of ended rides by passenger (waiting for driver to alight)
    nearbySiilors: "",
    nearbySongthaews: "",
    nearbyMotocys: "",
    rideCount: 0,
    menuItemPlaceholderPic: menuItemPlaceholderPic,
    errorProfilePic: errorProfilePic,
    birdProfilePic: birdProfilePic,
    newCustomersPic: newCustomersPic,
    geolocationPic: geolocationPic,
    siilorsPic: siilorsPic,
    siilorIcon: siilorIcon,
    songthaewsPic: songthaewsPic,
    songthaewIcon: songthaewIcon,
    taxiIcon: taxiIcon,
    vipTaxiIcon: vipTaxiIcon,
    publicTuktukIcon: publicTuktukIcon,
    welcomeTo: false, // set true to trigger welcome to message (not on first load tho...)
    geolocationPrompted: false, // set true after geolocation prompt has been shown
    selectedDriver: null, // used for dispatch, null or ''?
    referralCode: null, // set true if booking is from promo referral
    region: "", // Bangkok, Chiang Mai
    theme: "light", // light or dark
    agentMode: false,
    systemSpeed: 0, // this is API latency (getCustomerTransactions)
    cpuBenchmark: 0,
    notification: null,
    superpower: null,
    batchOrders: null,
    batchStartedAt: null,
    batchVehicleCount: 1,
    batchVehiclesCompleted: [], // array of vehicle numbers completed
    shopsOrServices: "shops", // shops or services
    routeHistory: [], // store route history, clear on each app start
    commerceOrder: null,
    messages: null,
    basket: null, // shopping basket
    qrScannerSound: 0, // to save unsafe sound in QRCodeScanner.vue
    logisticsFleet: [],
    networkErrors: [],
    shopHistory: [], // history of shop pages you've visited {key: name, value: id, count: 1}
    favorites: [], // hearts
    fakeGPS: false,
    fakeGPSLocation: null,
    hasInternet: true,
    ipAddress: null,
    storage: null,
    storagePersisted: null,
    driverSettingHideNewJobs: false,
    driverStats: null,
    driverCancelledAt: null,
    businessTypes: [
      "Apartment",
      "Condominium",
      "Hotel",
      "Songthaew",
      "Tuk Tuk",
      "Sii Lor",
      "Motocy",
      "Taxi",
      "Bar",
      "Restaurant",
      "Shop",
      "Travel Agency",
      "Service",
      "Other",
    ],
  },
  getters: getters, // store.getters...
  mutations: mutations, // Synchronous, use like commit("func")
  actions: actions, // Asynchronous, e.g. API call, use like dispatch("func")
});
